import { jsx as l } from "react/jsx-runtime";
import { forwardRef as p, Children as m } from "react";
import { f as a } from "../../../index-CZ8zjHGv.js";
import { normaliseResponsiveProp as c } from "../../../utils/responsiveProps.js";
import u from "../Box/Box.js";
import "styled-components";
const b = p(
  ({ children: t, space: n, align: o = "start" }, i) => /* @__PURE__ */ l(u, { ref: i, display: "flex", flexDirection: "column", width: "100%", children: m.map(a(t), (e, r) => /* @__PURE__ */ l(
    u,
    {
      ...d({
        space: n,
        index: r,
        align: o
      }),
      width: "100%",
      children: e
    },
    typeof e == "object" && e.key || r
  )) })
);
function d({ space: t, align: n, index: o }) {
  const i = c(n), { display: e, justifyContent: r } = i.reduce(
    (f, s) => ({
      display: [...f.display, y(s)],
      justifyContent: [
        ...f.justifyContent,
        C(s)
      ]
    }),
    {
      display: [],
      justifyContent: []
    }
  );
  return o === 0 ? { display: e, justifyContent: r } : { marginTop: t, display: e, justifyContent: r };
}
function y(t) {
  return t === "end" || t === "center" ? "flex" : "block";
}
function C(t) {
  return t === "end" ? "flex-end" : t === "center" ? "center" : "flex-start";
}
export {
  b as default
};
